import React, { useState } from 'react';
import {
  Container,
  Modal,
  Backdrop,
  CloseButton,
} from '../../styles/TwilioVerification.styled';
import TwilioForm from './TwilioForm';
import TwilioApproved from './TwilioApproved';
import TwilioError from './TwilioError';
import Icon from '../../../../molecules/Icon';

const TwilioVerification = ({
  phone,
  email,
  showTwilioVerification,
  setShowTwilioVerification,
  setTwilioVerified,
  verifyType,
}) => {
  const [verificationStatus, setVerificationStatus] = useState('pending');

  return (
    <Modal className={showTwilioVerification ? 'modal-active' : ''}>
      <Backdrop>
        <Container>
          <CloseButton onClick={() => setShowTwilioVerification(false)}>
            <Icon id="x-close" width="24px" height="24px" />
          </CloseButton>
          {verificationStatus === 'pending' && (
            <TwilioForm
              phone={phone}
              email={email}
              setTwilioVerified={setTwilioVerified}
              setVerificationStatus={setVerificationStatus}
              setShowTwilioVerification={setShowTwilioVerification}
              verifyType={verifyType}
            />
          )}
          {verificationStatus === 'approved' && (
            <TwilioApproved
              setShowTwilioVerification={setShowTwilioVerification}
            />
          )}
          {verificationStatus === 'canceled' && (
            <TwilioError
              setShowTwilioVerification={setShowTwilioVerification}
              setVerificationStatus={setVerificationStatus}
            />
          )}
        </Container>
      </Backdrop>
    </Modal>
  );
};

export default TwilioVerification;
